import { ContactAddresses } from 'assets/js/pages/contacts/ContactAddresses';
import { ContactCommunicationPreferences } from 'assets/js/pages/contacts/ContactCommunicationPreferences';
import { ContactCustomFieldsSection } from 'assets/js/pages/contacts/ContactCustomFieldsSection';
import { ContactDetails } from 'assets/js/pages/contacts/ContactDetails';
import { ContactSidebarGivingSummaryChart } from 'assets/js/pages/contacts/ContactSidebarGivingSummaryChart';
import { ContactSidebarTags } from 'assets/js/pages/contacts/ContactSidebarTags';
import { ContactSocials } from 'assets/js/pages/contacts/ContactSocials';
import { ContactFiles } from 'assets/js/pages/contacts/contact-files/ContactFiles';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentContact } from 'customHooks/useCurrentContact';

const ContactProfile = () => {
    const { data: contact } = useCurrentContact();
    const { hasGivebutterPlusAccess } = useCurrentAccount();
    const showContactFiles = hasGivebutterPlusAccess;

    return (
        <div className={'flex flex-col gap-4'}>
            <ContactDetails />
            <ContactCommunicationPreferences />
            <ContactAddresses />
            <ContactSocials />
            <ContactCustomFieldsSection />
            {showContactFiles ? <ContactFiles /> : null}

            <div className={'flex flex-col gap-4 sm:hidden'}>
                <ContactSidebarGivingSummaryChart />
                <ContactSidebarTags key={contact.id} />
            </div>
        </div>
    );
};

export { ContactProfile };
